<template>
  <el-config-provider :locale="locale">
    <div class="row">
      <!-- 路由页面 -->
      <router-view />
    </div>
  </el-config-provider>
</template>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.main-content {
  flex: 1;
  // background-color: rgb(242 242 242);
  height: 100vh;
  padding-left: 0 !important;
  overflow: auto;
}

.warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}

.success-row {
  --el-table-tr-bg-color: var(--el-color-success-light-9);
}

.iconfont {
  font-size: 1.25rem !important;
}

::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
  border: 3px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>

<script>
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
export default {
  data() {
    return {
      isNavOpen: true,
      locale: zhCn,
    }
  },
  components: {
    ElConfigProvider
  },
  methods: {
  },
}
</script>
